import { Meta, MetaDefinition} from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetaInfoService {
  constructor(private readonly metaService: Meta,
              private readonly translate: TranslateService) {

  }

  public addTag(metaTag: MetaDefinition, translation: boolean): void {
    if (translation) {
      this.translate.get(metaTag.content).pipe(
        take(1)
      ).subscribe((content) => {
        const tag = {...metaTag, content};
        this.metaService.addTag(tag);
      });
    } else {
      this.metaService.addTag(metaTag);
    }
  }
}
